import { useQuery } from "@apollo/client";

import { BLUEPRINT_DEPLOYMENT_QUERY } from "./gql";

type UseDeploymentParams = {
  blueprintId: string;
  deploymentId: string;
};

const useTemplateDeployment = ({ blueprintId, deploymentId }: UseDeploymentParams) => {
  const { data, loading, error } = useQuery(BLUEPRINT_DEPLOYMENT_QUERY, {
    variables: {
      blueprintID: blueprintId,
      id: deploymentId,
    },
    skip: !blueprintId || !deploymentId,
  });

  return {
    deployment: data?.blueprintDeployment,
    loading,
    error,
  };
};

export default useTemplateDeployment;
